import React from 'react';

export const UserAccountContext = React.createContext({
  account: null,
  subscriptionStatus: null,
  onUpdateSubscription: () => {}
});



// WEBPACK FOOTER //
// ./src/contexts/userAccount.js